import { SimpleEventDispatcher } from 'ste-simple-events';

export const customerComplianceDocumentEvents = {
  changed: new SimpleEventDispatcher<number>(),
};
